import { type Entry, type Params } from '../hooks/usePulseQuestionsChartData';
import { type HttpClient } from '../useHttpClient';

export const getPulseQuestionsChartData =
  (httpClient: HttpClient) => async (params: Params) => {
    const queryString = new URLSearchParams(
      params as unknown as Record<string, string>
    ).toString();

    const response = await httpClient.api(`/admin/pulse/chart?${queryString}`, {
      method: 'GET',
    });

    return response.json as Entry[];
  };
